import { useState } from 'react';
import { auth, storage, db } from '../firebase/config';
import { createUserWithEmailAndPassword, updateProfile } from 'firebase/auth';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { doc, setDoc } from 'firebase/firestore';

export const useSignup = () => {
  const [error, setError] = useState(null);
  const [isPending, setIsPending] = useState(false);

  const signup = async (email, password, displayName, profileImage) => {
    setError(null);
    setIsPending(true);

    try {
      // Create user with email and password
      const res = await createUserWithEmailAndPassword(auth, email, password);

      if (!res.user) {
        throw new Error('Could not complete signup');
      }

      // Upload profile image to Firebase Storage
      let photoURL = null;
      if (profileImage) {
        const uploadPath = `profileImages/${res.user.uid}/${profileImage.name}`;
        const storageRef = ref(storage, uploadPath);
        await uploadBytes(storageRef, profileImage);
        photoURL = await getDownloadURL(storageRef);
      }

      // Update the user profile with display name and photo URL
      await updateProfile(res.user, {
        displayName,
        photoURL
      });

      // Create a user document in Firestore
      await setDoc(doc(db, 'users', res.user.uid), {
        displayName,
        email,
        photoURL,
        uid: res.user.uid,
        createdAt: new Date(),
      });

      setIsPending(false);
    } catch (err) {
      console.error(err.message);
      setError(err.message);
      setIsPending(false);
    }
  };

  return { signup, error, isPending };
};